import {Component, OnInit} from '@angular/core';
import {BundeslandFilterService} from '../../../../service/bundeslandFilter/bundesland-filter.service';
import {DatastoreService} from '../../../../service/datastore/datastore.service';
import {FirebaseService} from '../../../../service/firebase/firebase.service';
import {catchError, map, shareReplay, take} from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Observable, of} from 'rxjs';
import {VorhersageHeute} from '../../../../model/vorhersagen/vorhersage-zehn-tage';

@Component({
  selector: 'app-automatisiert',
  templateUrl: './automatisiert.component.html',
  styleUrls: ['./automatisiert.component.css']
})
export class AutomatisiertComponent implements OnInit {
  selectedIndex = 0;

  vorhersagen$: Observable<VorhersageHeute[]> = new Observable<VorhersageHeute[]>();
  error$: Observable<any> = new Observable<any>();

  constructor(public bundeslandFilter: BundeslandFilterService,
              private datastoreService: DatastoreService,
              private firebaseService: FirebaseService) {

  }

  ngOnInit(): void {
    this.loadData();
  }

  hasBlnBrbFilterSet() {
    return this.bundeslandFilter.getSelectedBundesLaenderNamen().includes('Brandenburg')
      || this.bundeslandFilter.getSelectedBundesLaenderNamen().includes('Berlin');
  }

  private loadData() {
    if (this.datastoreService.vorhersagen24hHeute === undefined) {
      console.log(this.datastoreService.vorhersagen24hHeute);
      this.vorhersagen$ = this.firebaseService.getVorhersagenDeutschlandHeute24h(this.bundeslandFilter.getSelectedBundesLaenderNamen())
        .pipe(take(1), map(data => this.datastoreService.mapDataTo24hHeuteVorhersagen(data, false)));

      this.error$ = this.vorhersagen$.pipe(shareReplay(1), catchError(err => {
        console.log('ERROR', err);
        return of(true);
      }));
    }


  }
}
